export const featuresConfigSelector = state => {
  return state.preferences?.features;
};

export const bigClubSettingsSelector = state => {
  return state.preferences?.bigClubSettings;
};
